"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMemoOptionsWithLimit = exports.MAX_OPTIONS = void 0;
var _react = require("react");
var MAX_OPTIONS = exports.MAX_OPTIONS = 10000;
var useMemoOptionsWithLimit = exports.useMemoOptionsWithLimit = function useMemoOptionsWithLimit(options) {
  return (0, _react.useMemo)(function () {
    var _shouldSlice = (options === null || options === void 0 ? void 0 : options.length) > MAX_OPTIONS;
    return _shouldSlice ? options.slice(0, MAX_OPTIONS) : options;
  }, [options]);
};